import {
  SET_UNITS_V2,
  SET_UNITS_CONFIG_V2,
  GET_UNITS_STATIONS_PARENT,
  SET_UNITS_INPUTS,
  UPDATE_UNIT_PIPE_CONDITIONS,
  UPDATE_UNIT_PLATFORM_CONDITIONS,
  UPDATE_UNIT_TANKS,
  SET_UNITS_SNAKBAR,
  SET_UNIT_TAGS_STATION,
  MARK_UNIT_TAGS_STATION,
  RESET_UNIT_DATA,
  SET_UNITS_VERSIONS,
  UPDATE_UNIT_CONFIG,
  CHECK_UNIT_TAG_DISPENSER,
  TO_SAVE_UNIT_DATA,
  RESET_UNIT_TAGS_STATION,
  RESET_UNITS_SNAKBAR,
  RESET_UNITS_ERROR_V2,
  SET_UNIT_VIEW,
  SET_SUGGESTED_FAILED,
  LOAD_UNITS_V2,
  SELECT_STATION,
  CLEAN_STATION,
  CLEAN_UNITS_CONFIG,
  SELECT_COMPANY,
  CLEAN_COMPANY,
  UPDATE_UNIT_MAINTENANCE,
  SET_UNITS_NFC,
  UPDATE_UNIT_NFC,
  DELETE_UNIT_NFC,
  UNIT_STATION_TRANSFER,
  SET_SUGGESTED_UNITS,
} from "redux/reducers/units_v2/unitsReducer";
import { PROYECT, api_post, api_put, api_get, api_delete } from "services/api";
import { setSnackbar, startRequestComp, stopRequestComp } from "../search/searchActions";
import { updateNfcTagStatus } from "redux/actions/nfcTags/nfcTagsAction";
import { fetchUnitSuggestions } from "services/rapidcanvas";

const TIMEOUT_MESSAGE = "TIMEOUT";

export const setUnitsInputs = (value, key) => {
  return {
    type: SET_UNITS_INPUTS,
    payload: {
      value,
      key,
    },
  };
};
export const toggleUnitsView = () => {
  return {
    type: SET_UNIT_VIEW,
  };
};
export const getUnitsV2 = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/units/`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingUnits"));
    await api_get(url)
      .then((resp) => {
        dispatch({
          type: SET_UNITS_V2,
          payload: resp,
        });
      })
      .catch((err) => {
        dispatch(setSnackbar(err));
      });
    dispatch(stopRequestComp("loadingUnits"));
  };
};

export const getNfc = () => {
  const url = `${process.env.REACT_APP_URL}/crm/nfc`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingUnitsActions'))
    await api_get(url).then(resp => {
      dispatch({
        type: SET_UNITS_NFC,
        payload: resp
      })
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp('loadingUnitsActions'))
  }
}

export const putNfcUnit = (form, beforeNfcTag, onClose) => {
  const url = `${process.env.REACT_APP_URL}/crm/units/nfc_tag/${form.idUnit}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingUnitsActions'))
    await api_put(url, form).then(resp => {
      dispatch({
        type: UPDATE_UNIT_NFC,
        payload: form
      })
      dispatch(updateNfcTagStatus(form.idNfcTag, "UNIT"))
      dispatch(updateNfcTagStatus(beforeNfcTag, "FREE"))
      dispatch(setSnackbar(resp.message, 'success'))
      onClose && onClose()
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp('loadingUnitsActions'))
  }
}

export const postNfcUnit = (form, onClose) => {
  const url = `${process.env.REACT_APP_URL}/crm/units/nfc_tag`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingUnitsActions'))
    await api_post(url, form).then(resp => {
      dispatch({
        type: UPDATE_UNIT_NFC,
        payload: form
      })
      dispatch(updateNfcTagStatus(form.idNfcTag, "UNIT"))
      dispatch(setSnackbar(resp.message, 'success'))
      onClose && onClose()
    }).catch(err => {
      dispatch(setSnackbar(err, 'danger'))
    })
    dispatch(stopRequestComp('loadingUnitsActions'))
  }
}

export const deleteNfcUnit = (body, onClose, action) => {
  const url = `${process.env.REACT_APP_URL}/crm/nfc_tags/${body.idNfcTag}`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingUnitsActions'))
    await api_delete(url).then(_resp => {
      dispatch({
        type: DELETE_UNIT_NFC,
        payload: body.idUnit
      })
      dispatch(updateNfcTagStatus(body.idNfcTag, "FREE"))
      dispatch(setSnackbar(`Etiqueta NFC ${body.uuidTag} eliminada`, 'success'))
      onClose && onClose()
      action && action()
    }).catch(err => {
      dispatch(setSnackbar(err, 'danger'))
    })
    dispatch(stopRequestComp('loadingUnitsActions'))
  }
}

export const updateMaintenanceStatus = (id, form, action = null) => {
  const url = `${process.env.REACT_APP_URL}/crm/units/${id}/is-maintenance`
  return async (dispatch) => {
    dispatch(startRequestComp('loadingUnitsActions'))
    await api_put(url, form).then(resp => {
      dispatch({
        type: UPDATE_UNIT_MAINTENANCE,
        payload: { id, form }
      })
      dispatch(setSnackbar(resp?.message ? resp.message : "Guardado Exitoso", 'success'))
      action && action()
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp('loadingUnitsActions'))
  }
}

export const getUnitsConfigs = (station = '') => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/units/conf?idStation=${station}`
  return async (dispatch) => {
    dispatch(startRequestComp("loadingUnits"));
    await api_get(url)
      .then((resp) => {
        dispatch({
          type: SET_UNITS_CONFIG_V2,
          payload: resp,
        });
      })
      .catch((err) => {
        dispatch(setSnackbar(err));
      });
    dispatch(stopRequestComp("loadingUnits"));
  };
};

export const getStationsParent = (idStation = "") => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/stations/parent/${idStation}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingUnitsParents"));
    await api_get(url)
      .then((resp) => {
        dispatch({
          type: GET_UNITS_STATIONS_PARENT,
          payload: resp,
        });
        // if(resp.length === 0) dispatch(setSnackbar('No se encontraron Datos', 'warning'))
      })
      .catch((err) => {
        dispatch(setSnackbar(err));
      });
    dispatch(stopRequestComp("loadingUnitsParents"));
  };
};

export const getUnitsVersions = () => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/units/versions`;
  return async (dispatch) => {
    dispatch({ type: LOAD_UNITS_V2 });
    await api_get(url)
      .then((resp) => {
        dispatch({
          type: SET_UNITS_VERSIONS,
          payload: resp.map((v) => ({
            ...v,
            label: `${v?.name}${v?.description ? " - " + v.description : ""}`,
            value: v.id,
          })),
        });
      })
      .catch((err) => {
        dispatch(setSnackbar(err));
      });
  };
};

export const postPipeConditionUnit = (form) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/pipe_conditions`;
  return async (dispatch) => {
    dispatch({ type: LOAD_UNITS_V2 });
    await api_post(url, [form])
      .then((resp) => {
        dispatch({
          type: UPDATE_UNIT_PIPE_CONDITIONS,
          payload: resp[0],
        });
        dispatch(setSnackbar("Guardado completado", "success"));
      })
      .catch((err) => {
        dispatch(setSnackbar(err));
      });
  };
};

export const putPipeConditionUnit = (form) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/pipe_conditions`;
  return async (dispatch) => {
    dispatch({ type: LOAD_UNITS_V2 });
    await api_put(url, form)
      .then((resp) => {
        dispatch({
          type: UPDATE_UNIT_PIPE_CONDITIONS,
          payload: resp,
        });
        dispatch(setSnackbar("Guardado completado", "success"));
      })
      .catch((err) => {
        dispatch(setSnackbar(err));
      });
  };
};

export const postPlatformConditionUnit = (form) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/platform_conditions`;
  return async (dispatch) => {
    dispatch({ type: LOAD_UNITS_V2 });
    await api_post(url, [form])
      .then((resp) => {
        dispatch({
          type: UPDATE_UNIT_PLATFORM_CONDITIONS,
          payload: resp[0],
        });
        dispatch(setSnackbar("Guardado completado", "success"));
      })
      .catch((err) => {
        dispatch(setSnackbar(err));
      });
  };
};

export const putPlatformConditionUnit = (form) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/platform_conditions`;
  return async (dispatch) => {
    dispatch({ type: LOAD_UNITS_V2 });
    await api_put(url, form)
      .then((resp) => {
        dispatch({
          type: UPDATE_UNIT_PLATFORM_CONDITIONS,
          payload: resp,
        });
        dispatch(setSnackbar("Guardado completado", "success"));
      })
      .catch((err) => {
        dispatch(setSnackbar(err));
      });
  };
};

export const sendConfigUnitV2 = ( // ESTO NECESITARA UN REFACTOR {}
  id,
  form,
  imei = false,
  dispenser = false,
  tempId = "",
  onSuccess = null
) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/${dispenser ? "dispensers" : "units"
    }/${id}/${imei ? "user" : "configuration"}`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingConfigEdit"));
    dispatch({ type: LOAD_UNITS_V2 });
    await api_put(url, form)
      .then((resp) => {
        imei && dispenser
          ? dispatch({
            type: UPDATE_UNIT_CONFIG,
            payload: { unitId: tempId, resp },
          })
          : dispatch({
            type: UPDATE_UNIT_CONFIG,
            payload: resp,
          });
        dispatch(setSnackbar("Guardado completado", "success"));
        onSuccess && onSuccess();
      })
      .catch((err) => {
        dispatch(setSnackbar(err));
      });
    dispatch(stopRequestComp("loadingConfigEdit"));
  };
};

export const sendUnitManualConf = (id, status) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/units/${id}/unitManualConf?status=${status}`;
  return async (dispatch) => {
    dispatch({ type: LOAD_UNITS_V2 });
    await api_put(url)
      .then((resp) => {
        dispatch({
          type: UPDATE_UNIT_CONFIG,
          payload: resp,
        });
        dispatch(setSnackbar("Actualizado correctamente", "success"));
      })
      .catch((err) => {
        dispatch(setSnackbar(err));
      });
  };
};

export const sendVersionUnit = (id, idVersion, optionSelected) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/units/${id}/version/${idVersion ? idVersion : null
    }`;
  return async (dispatch) => {
    dispatch(startRequestComp('loadingUnitsActions'))
    dispatch({ type: LOAD_UNITS_V2 })
    await api_put(url).then(resp => {
      dispatch({
        type: UPDATE_UNIT_CONFIG,
        payload: {
          version: optionSelected,
          ...resp
        }
      })
      dispatch(setSnackbar(optionSelected?.label ? `Versión actualizada a ${optionSelected?.label}` : `Se elimino versión`, 'success'))
    }).catch(err => {
      dispatch(setSnackbar(err))
    })
    dispatch(stopRequestComp('loadingUnitsActions'))
  }
}

export const updateUnitTanks = (unit) => {
  return {
    type: UPDATE_UNIT_TANKS,
    payload: unit,
  };
};

export const selectStationAction = (id) => {
  return {
    type: SELECT_STATION,
    payload: id,
  };
};

export const setTagsStation = (data) => {
  return { type: SET_UNIT_TAGS_STATION, payload: data };
};

export const selectTagStation = (id) => {
  return { type: MARK_UNIT_TAGS_STATION, payload: id };
};

export const resetTagsStation = () => {
  return { type: RESET_UNIT_TAGS_STATION };
};
export const selectTagDispenser = (id) => {
  return { type: CHECK_UNIT_TAG_DISPENSER, payload: id };
};

export const resetTagsDispenser = () => {
  return { type: RESET_UNIT_TAGS_STATION };
};

export const selectCompanyAction = (id) => {
  return {
    type: SELECT_COMPANY,
    payload: id,
  };
};

export const handleCloseUnitErrors = () => {
  return {
    type: RESET_UNITS_ERROR_V2,
  };
};

export const cleanStation = () => {
  return {
    type: CLEAN_STATION,
    payload: "",
  };
};

export const cleanCompany = () => {
  return {
    type: CLEAN_COMPANY,
    payload: "",
  };
};

export const cleanUnitsConfig = () => {
  return {
    type: CLEAN_UNITS_CONFIG,
    payload: {},
  };
};


export const storeUnitData = (data) => {
  return {
    type: TO_SAVE_UNIT_DATA,
    payload: data,
  };
};

export const resetStoreUnitData = () => {
  return { type: RESET_UNIT_DATA };
};

export const setUnitTransfer = (form, action) => {
  const urlStation = `${process.env.REACT_APP_URL}${PROYECT}/units/transfer/${form.idUnit}/station`;
  const urlOperating = `${process.env.REACT_APP_URL}${PROYECT}/units/transfer/${form.idUnit}/operating`;
  return async (dispatch) => {
    dispatch(startRequestComp("loadingUnitsTransfer"));
    try {
      let responseStation;
      if (form?.idStation)
        responseStation = await api_put(urlStation, {
          idStation: form.idStation,
        });

      if (form?.idOperating && !form?.idStation)
        await api_put(urlOperating, {
          idOperating: form.idOperating,
        });

      dispatch({
        type: UNIT_STATION_TRANSFER,
        payload: {
          idStation: responseStation ? form.idStation : null,
          idOperating: form.idOperating,
          idUnit: form.idUnit,
        },
      });
      action && action();
      dispatch(setSnackbar("Transferencia realizada con éxito", "success"));
    } catch (error) {
      dispatch(setSnackbar(error));
    }
    dispatch(stopRequestComp("loadingUnitsTransfer"));
  };
};

export const loadSuggestedUnits = (
  qty,
  address,
  latitude,
  longitude,
  unitType,
  brandName,
  date,
  schedule,
  idStation,
  idCall,
  idRequest,
  numResults = 1,
  idService = null,
  idAccount = null,
  idCustomer = null,
  phoneNumber = null,
) => {
  return async (dispatch) => {
    dispatch(startRequestComp());
    const requestBody = {
      quantity: qty,
      endereco: address,
      latitude,
      longitude,
      unidad: unitType,
      fecha: date,
      hora: schedule,
      marca: brandName,
      n: numResults,
      id_station: idStation,
      id_call: idCall,
      id_service: idService,
      id_request: idRequest,
      id_account: idAccount,
      id_customer: idCustomer,
      phone_number: phoneNumber,
    };
    const start = Date.now();
    try {
      dispatch({ type: SET_SUGGESTED_FAILED, payload: false });
      if (!brandName) {
        return dispatch(
          setSnackbar(
            "No se cuenta con marca registrada en alguna unidad.",
            "info",
          ),
        );
      }

      const resp = await fetchUnitSuggestions(requestBody);
      const responseTime = `${(Date.now() - start) / 1000}s`;

      let parsedData = {};
      if (resp) {
        try {
          parsedData = typeof resp === "string" ? JSON.parse(resp) : resp;
        } catch (e) {
          parsedData = resp;
        }
      }

      const { eta_max, definitive_reason, ...restData } = parsedData;
      dispatch({
        type: SET_SUGGESTED_UNITS,
        payload: {
          ...restData,
          etaMax: eta_max || null,
          definitiveReason: definitive_reason || null,
          responseTime: responseTime,
          requestBody: JSON.stringify(requestBody),
          statusCode: "200",
        },
      });
      dispatch(stopRequestComp("component"));
    } catch (error) {
      dispatch(stopRequestComp("component"));
      const responseTime = !error.request?.status
        ? TIMEOUT_MESSAGE
        : `${(Date.now() - start) / 1000}s`;
      dispatch({
        type: SET_SUGGESTED_UNITS,
        payload: {
          responseTime: responseTime,
          requestBody: JSON.stringify(requestBody),
          statusCode: (
            error?.response?.status ||
            error.request?.status ||
            "TIMEOUT"
          ).toString(),
        },
      });
    }
  };
};

export const updateFlowmeter = (idUnit, idDispenser, body, onClose = null) => {
  return async (dispatch) => {
    dispatch(startRequestComp("loadingUpdateFlowmeter"));
    const url = `${process.env.REACT_APP_URL}${PROYECT}/units/support/change-flowmeter/${idUnit}/${idDispenser}`;
    try {
      await api_put(url, body);
      dispatch(setSnackbar("Guardado completado", "success"));
      onClose && onClose();
    } catch (error) {
      dispatch(setSnackbar(error));
    }
    dispatch(stopRequestComp("loadingUpdateFlowmeter"));
  };
};
